


















 import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
 import * as analysesServices from '@/services/analyses';
 import ConfirmationModal from "@/components/confirmationModal/ConfirmationModal.vue";
import Loading from '@/components/loading/Loading.vue';
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import { Analysis } from '@/api/analyses/types';

 @Component({
   name: 'AnalysisDelete',
   components: {
    ConfirmationModal,
    Loading,
    AgroIcons,
   },
 })

export default class AnalysisDelete extends Vue {
  @Prop(Object)
  private analysis!: Analysis;

  private confirmationOpen = false;
  private isLoading = false;

  private sendAnalysisToDelete() {
    this.confirmationOpen = true;
  }
  
  private closeAnalysisDelete() {
    this.confirmationOpen = false;
  }

  @Emit('analysis:delete')
  private async deleteAnalysis() {
    this.isLoading = true;
    await analysesServices.deleteAnalysisWithoutStore(this.analysis!);
    this.closeAnalysisDelete();
    this.isLoading = false;
  }
}
